<template>
  <el-container>
    <el-header>
      <span class="back-btn" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
    </el-header>
    <el-main>
      <Mark></Mark>
    </el-main>
  </el-container>
</template>
<script>
import Mark from "@/views/show/mark-list";
export default {
  components: {
    Mark,
  },
  methods: {
    back: function () {
      this.$router.go(-1)
    }
  },
}
</script>
<style scoped>
</style>